import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    // ranch
    sid: null,
    user: null,

    // dartcome
    u: null,
    me: null,

    // nutsbp
    cardinfo: null
  },
  getters: {
    uuid: (state) => {
      return _.get(state.user, 'uuid') ||
        _.get(state.me, 'uuid') ||
        _.get(state.cardinfo, 'uuid')
    },
    account: state => _.get(state.me, 'account'),
    homeUrl: (state, getters) => `${location.origin}/u/${getters.account}`,
    headImgUrl: (state) => {
      let url = _.get(state.me, 'card.head_image_url')
      if (url) {
        return url
      }
      return 'https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_small.png'
    }
  },
  mutations: {
    sid (state, payload) { state.sid = payload },
    user (state, payload) { state.user = payload },
    u (state, payload) { state.u = payload },
    me (state, payload) { state.me = payload },
    cardinfo (state, payload) { state.cardinfo = payload },
    mergeCardinfo (state, payload) { state.cardinfo = _.merge({}, state.cardinfo, payload) }
  },
  actions: {
    async cardinfo ({state, commit, dispatch}) {
      let data = await dispatch('api/nutsbp/cardinfo', {}, {root: true})
      commit('mergeCardinfo', data)
      return data
    },
    async createInitialModule ({dispatch}) {
      let data = await Promise.all([
        dispatch('api/dartcome/createUserModule', {
          type: 'preference',
          data: {
            amount: [0, 0], // [min, max]
            field: [], // [id, ...]
            stage: [] // ["A", "B", ...]
          }
        }, {root: true}),
        dispatch('api/dartcome/createUserModule', {
          type: 'case',
          data: [
            {
              desc: '', // string(2048)
              industry: '', // string(32)
              name: '' // string(32)
            }
          ]
        }, {root: true})
      ])
      console.log('createInitialModule', 'data', data)
    },
    async logout ({dispatch}) {
      dispatch('clear', null, {root: true})
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/me/index.js